import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import moment from "moment";
import NOTIFICATION_TYPES from "MODULES/Notifications/notificationTypes";
import { withRouter } from "react-router";

function Notification({ notification, onDelete, markRead, history }) {
  try {
    const { id, created_at, read } = notification;
    const { icon, iconUrl, url, message } = NOTIFICATION_TYPES[
      notification.notifier_type
    ][notification.notification_type];
    const handleDeleteClick = ev => {
      ev.preventDefault();
      onDelete(id);
    };

    const classes = classNames({ "text-bold": !read });

    return (
      <li
        style={{
          cursor: "pointer",
          backgroundColor: read
            ? "rgba(255, 255, 255, 0.02)"
            : "rgba(255, 255, 255, 0.1)"
        }}
      >
        <a
          onClick={ev => {
            ev.preventDefault();
            markRead(notification.id);
            history.push(url(notification));
          }}
        >
          <button
            type="button"
            className="close"
            aria-label="Delete"
            onClick={handleDeleteClick}
          >
            <span className="notification-close">
              <i className="fa fa-close" />
            </span>
          </button>
          <span className={classes}>{message(notification)}</span>
          <br />
          {iconUrl ? (
            <img src={iconUrl} height="17px" alt={notification.notifier_type} />
          ) : (
            <i className={`fa fa-fw text-muted ${icon}`} />
          )}
          &nbsp;
          <em className="small text-muted">{moment(created_at).calendar()}</em>
        </a>
      </li>
    );
  } catch (error) {
    return (
      <li style={{ cursor: "pointer" }}>
        <a>
          <span style={{ color: "red" }}>
            Error loading notification type{" "}
            <strong>{notification.notification_type}</strong>: {error.message}
          </span>
        </a>
      </li>
    );
  }
}

export default withRouter(Notification);

Notification.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    created_at: PropTypes.string.isRequired
  }).isRequired,
  onDelete: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/Nav/Notifications/Notification.jsx